import { BasicClientCommand } from "./BasicClientCommand";
import { BasicModel } from "../../model/BasicModel";
import { NetworkInstance } from "@goodgamestudios/world-assignment";
import { ExternalInterface } from "@goodgamestudios/createjs-utilities";

export class BasicReloadPageWithZoneIdCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        let selectedInstance: NetworkInstance = <NetworkInstance>commandVars;

        if (selectedInstance) {
            BasicModel.networkCookie.instanceId = selectedInstance.instanceId;
            BasicModel.networkCookie.zoneId = selectedInstance.zoneId + "";

            if (ExternalInterface.available) {
                ExternalInterface.call("ggsReloadGameClient");
            } else {
                location.reload();
            }
        }
    }
}
